export default {
  email_confirm: {
    header: {
      title: '已完成電子郵件地址確認',
    },
    completed: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
      // section_four: '',
    },
    expired: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
    },
    btn: {
      // service_top: '',
      // login: '',
      register: '登錄',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
